import React, { FC, SVGProps } from 'react';

export const Checkmark: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 20.1312C16.0432 20.1312 20.1315 16.0428 20.1315 10.9997C20.1315 5.95647 16.0432 1.86816 11 1.86816C5.95681 1.86816 1.8685 5.95647 1.8685 10.9997C1.8685 16.0428 5.95681 20.1312 11 20.1312Z"
      fill="#BEDFE5"
    />
    <path
      opacity="0.15"
      d="M12.2176 18.9139C10.4849 18.9139 8.78804 18.4209 7.32507 17.4925C5.86211 16.5641 4.69346 15.2387 3.95561 13.671C3.21776 12.1033 2.94117 10.358 3.15813 8.63897C3.37509 6.91994 4.07665 5.29811 5.18088 3.96289C4.20083 4.77334 3.40088 5.77957 2.83227 6.91711C2.26365 8.05466 1.93892 9.29843 1.87887 10.5688C1.81882 11.8391 2.02478 13.1079 2.48355 14.294C2.94232 15.4802 3.64378 16.5574 4.54301 17.4566C5.44223 18.3559 6.51938 19.0575 7.70546 19.5163C8.89154 19.9752 10.1604 20.1812 11.4307 20.1213C12.701 20.0613 13.9448 19.7367 15.0824 19.1681C16.22 18.5996 17.2263 17.7997 18.0368 16.8197C16.4012 18.1761 14.3424 18.917 12.2176 18.9139Z"
      fill="#104B0B"
    />
    <path
      d="M11 20.8811C16.4574 20.8811 20.8815 16.4571 20.8815 10.9997C20.8815 5.54226 16.4574 1.11816 11 1.11816C5.54256 1.11816 1.11847 5.54226 1.11847 10.9997C1.11847 16.4571 5.54256 20.8811 11 20.8811Z"
      stroke="#104B0B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.65112 11.0046L10.3881 13.7416L15.2616 8.86816"
      stroke="#104B0B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
